import React, { useEffect, useRef, useState } from "react";
import { httpCreateGroup, httpUpdateGroup } from "./api/calls";
import { useDispatch, useSelector } from "react-redux";
import { getGroups } from "../../../../Redux/Actions/skill_matrix_actions";

const AddGroupModal = ({ group, setSelectedGroup }) => {
  const dispatch = useDispatch();
  const { departments } = useSelector((state) => state.skillMatrix);
  const cancelRef = useRef(null);
  const initialValues = {
    name: "",
    code: "",
    dept_id: "",
  };
  const [values, setValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    if (group) setValues(group);
  }, [group]);

  const handleCancel = () => {
    setSelectedGroup(null);
    setValues(initialValues);
  };

  const handleSubmit = () => {
    if (name === "" || code === "" || dept_id === "")
      return alert("All fields are required");
    httpCreateGroup({ ...values, dept_id: +dept_id }).then((res) => {
      if (res.status) {
        setValues(initialValues);
        cancelRef.current.click();
        dispatch(getGroups());
        return alert(res.msg);
      } else {
        return alert(res.msg);
      }
    });
  };

  const handleUpdate = async () => {
    if (name === "" || code === "") return alert("All fields are required");
    const updatedValues = {
      name: values.name,
      code: values.code,
      dept_id: values.dept_id,
    };
    await httpUpdateGroup(group.id, updatedValues).then((res) => {
      if (res.status) {
        setValues(initialValues);
        cancelRef.current.click();
        dispatch(getGroups());
        return alert(res.msg);
      } else {
        return alert(res.msg);
      }
    });
  };

  const { name, code, dept_id } = values;
  // console.log('model')
  // console.log(group)
  return (
    <div
      className="modal fade"
      id="addgroup"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="float-end btn_close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="icon icon-cross"></i>
            </button>
            <div
              className="dash_white_box_ttl text-center"
              id="exampleModalLabel"
            >
              {group ? "Update" : "Add"} Skill Set
            </div>
            <form>
              <div className="mb-2">
                <label className="col-form-label">Department</label>
                <select
                  type="text"
                  className="form-select"
                  name="dept_id"
                  value={dept_id}
                  onChange={handleChange}
                >
                  <option value={""}>Select Department</option>
                  {departments &&
                    departments.map((dept, i) => {
                      return (
                        <option key={i} value={dept.id}>
                          {dept.name}
                        </option>
                      );
                    })}
                  <option value={"Department Name"}>Department Name</option>
                </select>
              </div>
              <div className="mb-2">
                <label className="col-form-label">Skill Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={handleChange}
                  name="name"
                  value={name}
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Skill Code</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={handleChange}
                  name="code"
                  value={code}
                />
              </div>
            </form>
            <div className="modalfooter">
              <button
                type="button"
                className="btn_6 float-end ml10"
                data-bs-dismiss="modal"
                ref={cancelRef}
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                onClick={group ? handleUpdate : handleSubmit}
                type="button"
                className="btn_5 float-end "
              >
                {group ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGroupModal;
